<template>
    <div id="add-salary-content" class="h-full flex flex-col justify-between add-salary-content">
        <div style="margin-bottom: 40px;">
            <!-- <h5 class="font-bold pt-6 pb-3">Salary by period</h5> -->
            <div class="flex align-center pt-6 pb-5">
                <vs-radio v-model="salary_type" :vs-value="0" class="mr-base"><h5 class="font-bold ml-2">Salary by period</h5></vs-radio>
                <vs-radio v-model="salary_type" :vs-value="1"><h5 class="font-bold ml-2">Wage per hour</h5></vs-radio>
            </div>
            <vs-input v-model="salaryValue" v-on:keypress="isNumber($event, salaryValue)"></vs-input>

            <div class="flex items-center pt-base mt-3 pb-5">
                <h5 class="font-bold mr-8">Choose Cash - Check Proportion</h5>

                <ul class="centerx flex align-center justify-between space-x-8">
                    <li class="flex items-center">
                        <vs-radio v-model="cashCheckType" name="cash-check-type" vs-value="percent">%</vs-radio>
                    </li>
                    <li class="flex items-center">
                        <vs-radio v-model="cashCheckType" name="cash-check-type" vs-value="usd">$</vs-radio>
                    </li>
                </ul>
            </div>
            <div class="my-radio-list flex" v-if="cashCheckType == 'percent'">
                <div v-for="(item, index) in cashCheckPercentage" :key="index">
                    <vs-button type="border" class="text-lg percentage-btn" :class="{'active': cashcheck_selected.id == item.id}" @click="selectItem(item)">
                        <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                        <span v-else-if="item.end == -1">Other</span>
                        <span v-else>{{item.start}} - {{item.end}}</span>
                    </vs-button>
                </div>
            </div>
            <div v-else>
                <div class="flex items-center">
                    <div class="fixed-cash-check-type-select">
                        <v-select @input="selectFixedCashCheckType($event)" :value="fixedCashCheckType" label="name" :options="fixedCashCheckTypeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
                    </div>
                    <vs-input class="fixed-cash-check-type-input" v-model="fixedCashCheckValue" v-on:keypress="isNumber($event, fixedCashCheckValue)"></vs-input>
                </div>
            </div>

            <div>
                <h5 class="font-bold pt-base mt-3 pb-3">Deduction Per Day</h5>
                <vs-input v-model="deductionPerDay" v-on:keypress="isNumber($event, deductionPerDay)"></vs-input>
            </div>

            <div class="my-base pt-3 flex">
                <div class="flex align-start">
                    <vs-switch class="credit-card-tip" v-model="creditCardTip" />
                    <span @click="creditCardTip = !creditCardTip" class="pl-6 cursor-pointer font-bold color-black" :class="{'text-primary': creditCardTip}" style="font-size: 15.96px">Credit card tips added to check</span>
                </div>

                <div class="percentage-charge-margin">
                    <h5 class="font-bold pb-3">Percentage charge(%)</h5>
                    <vs-input v-model="percentageCharge" v-on:keypress="isNumber($event, percentageCharge)" :disabled="creditCardTip == false"></vs-input>
                </div>
            </div>
        </div>

        <div class="flex justify-center py-6 bg-white border-top-custom bottom-group-btn">
            <vs-button class="commission-btn" @click="saveSalary">Finish</vs-button>
        </div>

        <vs-popup class="holamundo customize-percentage-popup" title="Customize Cash - Check Percentage" :active.sync="popupActive">
            <div class="text-center">
                <div class="flex align-center mb-4">
                    <p class="w-1/2 text-left">Percent for Cash</p>
                    <vs-input class="" v-model="customPercentage" v-on:keypress="isTwoDigitsAfterDecimalNumber($event, customPercentage)" />
                </div>

                <div class="flex align-center mb-4">
                    <p class="w-1/2 text-left">Percent for Check</p>
                    <vs-input class="" :value="formatPercentToShow(100 - customPercentage)" disabled />
                </div>
                <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                    <vs-button type="border" color="danger" class="mr-6 cancel-responsive" @click="popupActive = false">Cancel</vs-button>
                    <vs-button class="align-center delete-responsive" @click="saveOtherValue">Ok</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
    name: 'add-salary-content',
    components: { vSelect },
    props: {
        commissionSettingConfig: {
            type: Object,
            required: true
        }
    },
    data() {
        let cashCheckPercentage = [];
        let cashcheck_selected = {};
        let creditCardTip;
        let percentageCharge;
        let active_item;
        let popupActive;
        let customPercentage;
        let salaryValue;
        let salary_type;

        let cashCheckType;
        let deductionPerDay;
        let fixedCashCheckType;
        let fixedCashCheckValue;

        this.getDefault();
        return {
            cashCheckPercentage,
            cashcheck_selected,
            creditCardTip,
            percentageCharge,
            salaryValue,
            active_item,
            popupActive,
            customPercentage,
            salary_type,
            cashCheckType,
            fixedCashCheckType,
            fixedCashCheckValue,
            deductionPerDay,
            fixedCashCheckTypeOptions: [
                {
                    id: 1,
                    name: 'Cash'
                },
                {
                    id: 2,
                    name: 'Check'
                },
            ]
        }
    },
    watch: {
      commissionSettingConfig: {
        immediate: true,
        deep: true,
        handler(){
          this.getDefault();
        }
      }
    },
    methods: {
        formatPercent(value) {
            // return Math.round((value/100) * 100 + Number.EPSILON ) / 100;
            return +(Math.round(value*100 + "e+2") + "e-2");
        },
        formatPercentToShow(value) {
            return +(Math.round(value + "e+2") + "e-2");
        },
        formatPercentToPost(value) {
            return +(Math.round(value/100 + "e+4") + "e-4");
        },
        formatFloatNumToPost(value) {
            return +(Math.round(value/100 + "e+7") + "e-7");
        },
        formatSalaryNumber(value) {
            return +(Math.round(value + "e+3") + "e-3");
        },
        getDefault(){
            this.cashCheckPercentage = [
                {id: 1, start: 70, end: 30, name: '70-30', type: 'cashcheck'},
                {id: 2, start: 60, end: 40, name: '60-40', type: 'cashcheck'},
                {id: 3, start: 50, end: 50, name: '50-50', type: 'cashcheck'},
                {id: 4, start: 40, end: 60, name: '40-60', type: 'cashcheck'},
                {id: 5, start: 0, end: -1, name: 'other', type: 'cashcheck'}
            ],
            this.cashcheck_selected = {id: 1, start: 70, end: 30, name: '70-30', type: 'cashcheck'},
            this.creditCardTip = false,
            this.percentageCharge = 0,
            this.active_item = null,
            this.popupActive = false,
            this.customPercentage = 0,
            this.salaryValue = 0;
            this.salary_type = 0;
            this.cashCheckType = "percent";
            this.deductionPerDay = 0;
            this.fixedCashCheckType = "Cash";
            this.fixedCashCheckValue = 0;
        },
        saveSalary(){
            if(this.cashCheckType != "percent" && (!this.fixedCashCheckValue || this.fixedCashCheckValue == "0")) {
                this.$vs.notify({
                    title:'Notification',
                    text:'Fixed amount must be greater than 0',
                    color:'danger',
                    position:'top-right'
                });
                return;
            }
            const obj = {
                type: 'salary',
                salary_type: this.salary_type,
                // salary_by_period: this.salaryValue,
                cash_check_percentage: this.formatPercentToPost(this.cashcheck_selected.start),
                is_tip_to_check: this.creditCardTip ? 1 : 0,
                tip_to_check_percentage: this.creditCardTip ? this.formatFloatNumToPost(this.percentageCharge) : 0,
                deduction_per_day: this.deductionPerDay ? this.deductionPerDay : 0,
                cash_fixed_amount: this.fixedCashCheckType == "Cash" ? this.fixedCashCheckValue : 0,
                check_fixed_amount: this.fixedCashCheckType == "Check" ? this.fixedCashCheckValue : 0,
                is_fixed_amount: this.cashCheckType == "percent" ? 0 : 1
            }
            if(this.salary_type == 0) {
                obj.salary_by_period = this.formatSalaryNumber(this.salaryValue);
            } else {
                obj.salary_per_hour = this.formatSalaryNumber(this.salaryValue);
            }
            this.$emit("SaveSalary", obj)
        },
        selectItem(item) {
            if(item) {
                if(item.name != 'other') {
                    if(item.type == 'cashcheck') {
                        this.cashcheck_selected = item;
                    }
                } else {
                    console.log('open other popup');
                    this.active_item = item;
                    this.customPercentage = item.start;
                    this.popupActive = true;
                }
            }
        },
        isNumber: function(evt, num) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && num.toString().indexOf(".") != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        isIntegerNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                if(parseInt(this.customPercentage + '' + evt.key) <= 100) {
                    return true;
                } else {
                    evt.preventDefault();
                }
            }
        },
        isTwoDigitsAfterDecimalNumber: function(evt, num) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && num.toString().indexOf(".") != -1) ||
            ((charCode >= 48 && charCode <= 57) && num.toString().indexOf(".") != -1 && (num.toString().substring(num.toString().indexOf(".") + 1)).length == 2) || 
            ((charCode >= 48 && charCode <= 57) && parseFloat(num + '' + String.fromCharCode(charCode)) > 100)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        saveOtherValue() {
            if(this.customPercentage == '') {
                this.customPercentage = 0;
            }
            this.cashcheck_selected = this.active_item;
            this.cashcheck_selected.start = this.formatPercentToShow(this.customPercentage);
            this.cashcheck_selected.end = this.formatPercentToShow(100 - this.customPercentage);
            for(let i = 0 ; i < this.cashCheckPercentage.length; i++){
              if(this.cashcheck_selected.start == this.cashCheckPercentage[i].start){
                this.cashcheck_selected = this.cashCheckPercentage[i];
                this.active_item = this.cashcheck_selected;
              }
            }
            this.popupActive = false;
        },
        finishCommissionSetting() {
            this.$emit('FinishCommissionSetting', 'salary');
        },
        selectFixedCashCheckType(e) {
            this.fixedCashCheckType = e.name;
        },
    }
}
</script>
